import notFound from "./404.module.css"

function NotFound() {
    return (
        <main id="NotFound" className={notFound.NotFound}>
            <div className={notFound.content}>    
                <p className={notFound.P}>Oops! This page took a swim and never came back. 🏊‍♂️💨</p>
                <h1 className={notFound.H1}>404</h1>
            </div>
            <div className={notFound.buttons}>
                <a href="/">GO TO HOME</a>
                <p>OR</p>
                <a href="mailto:kiansegantini@gmail.com" target="_blank" rel="noreferrer">HIRE ME</a>
            </div>
        </main>
    );
}

export default NotFound;